// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import EscPosEncoder from 'esc-pos-encoder';
// import { usePrinter } from '../../context/PrinterContext';
// import authService from '../../services/authService';
// import CreditService from '../../services/creditService';
// import ToastService from '../../services/toastService';
// import ShiftService from '../../services/shiftService';
// import Sidebar from '../Sidebar/Sidebar';
// import './Credit.css';
//
// const Credit = () => {
//   const { characteristic } = usePrinter();
//   const navigate = useNavigate();
//   const [showSidebar, setShowSidebar] = useState(false);
//   const [collections, setCollections] = useState([]);
//   const [loading, setLoading] = useState({
//     collections: false,
//     submitting: false
//   });
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalPages: 1,
//     total: 0,
//     limit: 10
//   });
//   const [searchTerm, setSearchTerm] = useState('');
//   const [routeInfo, setRouteInfo] = useState(null);
//   const [shiftActive, setShiftActive] = useState(false);
//   const [dateRange, setDateRange] = useState({
//     startDate: '',
//     endDate: ''
//   });
//
//   // Modal states
//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [selectedCollection, setSelectedCollection] = useState(null);
//
//   // Payment form state
//   const [paymentForm, setPaymentForm] = useState({
//     method: 'CASH',
//     amount: '',
//     notes: '',
//     chequeNumber: '',
//     bank: '',
//     chequeDate: '',
//     reference: ''
//   });
//
//   const [paymentMethods, setPaymentMethods] = useState([]);
//
//   useEffect(() => {
//     // Check authentication
//     if (!authService.isAuthenticated()) {
//       ToastService.error('Session expired. Please login again.');
//       navigate('/login');
//       return;
//     }
//
//     // Check if shift is active and get routeId
//     checkShiftStatus();
//   }, [navigate]);
//
//   const generateCollectionReceipt = async ({
//     collection,
//     paymentMethods,
//     totals,
//     currentUser,
//     customerData,
//     routeInfo
//   }) => {
//     const encoder = new EscPosEncoder();
//
//     // Extract data
//     const invoiceNum = collection.code || `COL-${String(collection.id).padStart(6, '0')}`;
//     const paymentBatchCode = collection.paymentBatchCode || invoiceNum;
//     const currentTime = new Date().toLocaleTimeString('en-US', {
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true
//     });
//     const currentDate = new Date().toLocaleDateString('en-GB');
//
//     // Business information (same as CreateSale)
//     const businessName = "       Theresa Products";
//   const other = "    Distributor: Perera Brothers ";
//   const businessAddress = "NO 51/17, Kalyani Mawatha, Wattala";
//   const businessPhone = "Tel: +94 77 566 0327";
//
//     // Customer data
//     const customerName = customerData?.name || "Customer";
//     const customerCode = customerData?.code || "N/A";
//     const salesRep = currentUser?.firstName || "Sales Rep";
//     const routeName = routeInfo?.name || "Route";
//
//     // Get inventory info
//     const shiftDataStr = localStorage.getItem('current_shift');
//     let inventoryName = "Main Inventory";
//     if (shiftDataStr) {
//       const shiftData = JSON.parse(shiftDataStr);
//       inventoryName = shiftData.inventoryName || inventoryName;
//     }
//
//     // Payment totals
//     const totalAmount = totals.totalAmount || 0;
//     const paidAmount = totals.paidAmount || 0;
//     const remainingBalance = totals.remainingBalance || 0;
//     const isFullyPaid = remainingBalance <= 0;
//
//     // Build the receipt
//     const receipt = encoder
//       .initialize()
//       .codepage('cp858')
//
//       // ==================== BUSINESS HEADER ====================
//      .align('center')
//     .size(2, 2)
//     .bold(true)
//     .line(businessName)
//     .size(1, 1)
//     .bold(false)
//      .line(other)
//     .line(businessAddress)
//     .line(businessPhone)
//     .line('='.repeat(42))
//
//       // ==================== COLLECTION RECEIPT HEADER ====================
//       .align('center')
//       .size('double')
//       .bold(true)
//       .line('COLLECTION RECEIPT')
//       .size('normal')
//       .bold(false)
//       .line('='.repeat(42))
//
//       // ==================== COLLECTION DETAILS ====================
//       .align('left')
//       .bold(true)
//       .line('COLLECTION DETAILS')
//       .bold(false)
//       .line('='.repeat(42))
//       .line(`Receipt #  : ${invoiceNum}`)
//       .line(`Batch Code : ${paymentBatchCode}`)
//       .line(`Date/Time  : ${currentDate} ${currentTime}`)
//       .line(`Customer   : ${customerName.substring(0, 20)}`)
//       .line(`Cust Code  : ${customerCode.substring(0, 15)}`)
//       .line(`Sales Rep  : ${salesRep.substring(0, 15)}`)
//       .line(`Route      : ${routeName.substring(0, 15)}`)
//       .line(`Inventory  : ${inventoryName.substring(0, 15)}`)
//       .line('='.repeat(42))
//
//       // ==================== ORIGINAL CREDIT INFO ====================
//       .align('left')
//       .bold(true)
//       .line('ORIGINAL CREDIT')
//       .bold(false)
//       .line('─'.repeat(42))
//       .line(`Collection Code : ${invoiceNum}`)
//       .line(`Credit Amount   : Rs.${totalAmount.toFixed(2).padStart(10)}`)
//       .line('='.repeat(42));
//
//     // ==================== PAYMENT METHODS SECTION ====================
//     receipt
//       .align('left')
//       .bold(true)
//       .line('PAYMENT DETAILS')
//       .bold(false)
//       .line('='.repeat(42));
//
//     if (paymentMethods && paymentMethods.length > 0) {
//       // Table header for payments
//       receipt
//         .align('center')
//         .bold(true)
//         .line('Method        Amount')
//         .bold(false)
//         .line('='.repeat(42));
//
//       // Print each payment method
//       paymentMethods.forEach(payment => {
//         const method = (payment.method || 'CASH').substring(0, 12).padEnd(12);
//         const amount = (payment.amount || 0).toFixed(2).padStart(10);
//         receipt.line(`${method}Rs.${amount}`);
//
//         // Show payment details if available
//         if (payment.chequeNumber) {
//           receipt.line(`  Cheque: ${payment.chequeNumber}`);
//         }
//         if (payment.bank) {
//           receipt.line(`  Bank: ${payment.bank}`);
//         }
//         if (payment.reference) {
//           receipt.line(`  Ref: ${payment.reference}`);
//         }
//         if (payment.notes) {
//           receipt.line(`  Note: ${payment.notes.substring(0, 35)}`);
//         }
//         receipt.line('='.repeat(42));
//       });
//     } else {
//       receipt.line('No payment methods recorded');
//       receipt.line('='.repeat(42));
//     }
//
//     // ==================== SUMMARY SECTION ====================
//     receipt
//       .align('right')
//       .bold(true)
//       .line('SUMMARY')
//       .bold(false)
//       .line('='.repeat(42))
//       .line(`Credit Amount   : Rs.${totalAmount.toFixed(2).padStart(10)}`)
//       .line(`Amount Paid     : Rs.${paidAmount.toFixed(2).padStart(10)}`)
//       .line('='.repeat(42));
//
//     // Calculate remaining balance
//     const balance = totalAmount - paidAmount;
//
//     if (balance > 0) {
//       receipt
//         .bold(true)
//         .line(`Balance Due     : Rs.${balance.toFixed(2).padStart(10)}`)
//         .bold(false);
//     } else {
//       receipt
//         .bold(true)
//         .size('double')
//         .line('─'.repeat(42))
//         .line('FULLY PAID')
//         .size('normal')
//         .line('='.repeat(42))
//         .bold(false);
//     }
//
//     receipt.line('='.repeat(42));
//
//     // ==================== PAYMENT STATUS ====================
//     receipt
//       .align('center')
//       .bold(true);
//
//     if (isFullyPaid) {
//       receipt
//         .size('double')
//         .line('PAYMENT COMPLETE')
//         .size('normal');
//     } else if (paidAmount > 0) {
//       receipt
//         .line('PARTIAL PAYMENT RECEIVED');
//     } else {
//       receipt
//         .line('NO PAYMENT RECORDED');
//     }
//
//     receipt.bold(false);
//
//     // ==================== FOOTER ====================
//     receipt
//       .line('='.repeat(42))
//       .line(' ')
//       .align('center')
//       .bold(true)
//       .line('THANK YOU FOR YOUR PAYMENT!')
//       .bold(false)
//       .line('We appreciate your business')
//       .line('Please keep this receipt for your records')
//       .line(' ')
//       .size(1, 1)
//       .line('software by @fidesm.dev | +94 75 718 0225')
//       .newline()
//       .cut('partial');
//
//     // ENCODE the receipt
//     const encodedData = receipt.encode();
//
//     console.log('Collection receipt generated for:', invoiceNum);
//     return encodedData;
//   };
//
//   const printCollectionReceipt = async () => {
//     try {
//       if (!characteristic || !characteristic.writeValue) {
//         ToastService.error('Printer not connected. Please connect a printer first.', 'error', 3000);
//         return;
//       }
//
//       // Get current user
//       const currentUser = authService.getCurrentUser();
//
//       // Prepare customer data from selected collection
//       let customerData = {};
//
//       // Try to get customer info from collection data
//       if (selectedCollection?.credit?.customer) {
//         customerData = {
//           name: selectedCollection.credit.customer.name || "Customer",
//           code: `CUST-${String(selectedCollection.credit.customer.id).padStart(6, '0')}`
//         };
//       } else {
//         // Fallback to dummy data
//         customerData = {
//           name: "Customer",
//           code: "CUST"
//         };
//       }
//
//       // Prepare data for receipt
//       const receiptData = {
//         collection: selectedCollection,
//         paymentMethods: paymentMethods,
//         totals: {
//           totalAmount: selectedCollection?.amount || 0,
//           paidAmount: getTotalCollected(),
//           remainingBalance: getRemainingBalance()
//         },
//         currentUser: currentUser,
//         customerData: customerData,
//         routeInfo: routeInfo
//       };
//
//       // Generate receipt
//       const receipt = await generateCollectionReceipt(receiptData);
//
//       // Print the receipt in chunks (same as CreateSale)
//       const CHUNK_SIZE = 100;
//       const totalBytes = receipt.byteLength;
//       let offset = 0;
//
//       console.log(`Writing receipt (${totalBytes} bytes) in ${CHUNK_SIZE} byte chunks...`);
//
//       while (offset < totalBytes) {
//         const chunkSize = Math.min(CHUNK_SIZE, totalBytes - offset);
//         const chunk = receipt.slice(offset, offset + chunkSize);
//
//         // Send the chunk
//         await characteristic.writeValue(chunk);
//
//         // Delay between chunks
//         await new Promise(resolve => setTimeout(resolve, 100));
//
//         offset += chunkSize;
//       }
//
//       console.log('Collection receipt printed successfully!');
//       ToastService.success('Receipt printed successfully!', 'success', 2000);
//
//     } catch (error) {
//       console.error('Error printing receipt:', error);
//       ToastService.error('Failed to print receipt: ' + error.message, 'error', 3000);
//     }
//   };
//
//   useEffect(() => {
//     if (shiftActive && routeInfo?.id) {
//       fetchCollections();
//     }
//   }, [shiftActive, routeInfo?.id, pagination.currentPage, searchTerm, dateRange]);
//
//   const checkShiftStatus = () => {
//     const shiftDataStr = localStorage.getItem('current_shift');
//
//     if (shiftDataStr) {
//       const shiftData = JSON.parse(shiftDataStr);
//
//       if (shiftData.isActive && shiftData.routeId) {
//         setShiftActive(true);
//         setRouteInfo({
//           id: shiftData.routeId,
//           name: shiftData.routeName || 'Current Route'
//         });
//
//         const routeName = localStorage.getItem('currentRouteName');
//         if (routeName) {
//           setRouteInfo(prev => ({ ...prev, name: routeName }));
//         }
//       } else {
//         setShiftActive(false);
//         setRouteInfo(null);
//       }
//     } else {
//       setShiftActive(false);
//       setRouteInfo(null);
//     }
//
//     setLoading({ collections: false, submitting: false });
//   };
//
//   const fetchCollections = async () => {
//     try {
//       setLoading(prev => ({ ...prev, collections: true }));
//
//       // Use the direct method to get collections (not grouped by customer)
//       const response = await CreditService.getCollectionsDirect({
//         routeId: routeInfo.id
//       });
//
//       console.log('Direct collections response:', response);
//
//       let collectionsData = [];
//
//       if (response.success && response.data) {
//         // CASE 1: Direct collections array
//         if (Array.isArray(response.data.collections)) {
//           collectionsData = response.data.collections;
//         }
//         // CASE 2: Fallback to customers array
//         else if (Array.isArray(response.data.customers)) {
//           collectionsData = response.data.customers;
//         }
//         // CASE 3: Direct array in data
//         else if (Array.isArray(response.data)) {
//           collectionsData = response.data;
//         }
//       }
//
//       console.log('Extracted collections data:', collectionsData);
//
//       // Apply search filter
//       if (searchTerm) {
//         const lowerCaseSearch = searchTerm.toLowerCase();
//         collectionsData = collectionsData.filter(collection =>
//           collection.code?.toLowerCase().includes(lowerCaseSearch) ||
//           (collection.id?.toString() || '').includes(lowerCaseSearch) ||
//           collection.credit?.customer?.name?.toLowerCase().includes(lowerCaseSearch) ||
//           (collection.credit?.customer?.id?.toString() || '').includes(lowerCaseSearch)
//         );
//       }
//
//       // Apply date filter
//       if (dateRange.startDate || dateRange.endDate) {
//         collectionsData = collectionsData.filter(collection => {
//           if (!collection.createdAt) return true;
//
//           const creditDate = new Date(collection.createdAt);
//           const startDate = dateRange.startDate ? new Date(dateRange.startDate) : null;
//           const endDate = dateRange.endDate ? new Date(dateRange.endDate) : null;
//
//           let isInRange = true;
//           if (startDate && creditDate < startDate) isInRange = false;
//           if (endDate) {
//             const endOfDay = new Date(endDate);
//             endOfDay.setHours(23, 59, 59, 999);
//             if (creditDate > endOfDay) isInRange = false;
//           }
//
//           return isInRange;
//         });
//       }
//
//       // Calculate pagination
//       const total = collectionsData.length;
//       const totalPages = Math.ceil(total / pagination.limit);
//       const startIndex = (pagination.currentPage - 1) * pagination.limit;
//       const endIndex = startIndex + pagination.limit;
//
//       const paginatedData = collectionsData.slice(startIndex, endIndex);
//
//       console.log('Setting collections to display:', paginatedData);
//
//       setCollections(paginatedData);
//       setPagination(prev => ({
//         ...prev,
//         totalPages,
//         total,
//         hasNextPage: pagination.currentPage < totalPages,
//         hasPrevPage: pagination.currentPage > 1
//       }));
//
//     } catch (error) {
//       console.error('Error fetching collections:', error);
//       setCollections([]);
//       setPagination(prev => ({
//         ...prev,
//         totalPages: 0,
//         total: 0,
//         hasNextPage: false,
//         hasPrevPage: false
//       }));
//
//       if (error.message?.includes('401') || error.message?.includes('Session expired')) {
//         ToastService.error('Session expired. Please login again.');
//         navigate('/login');
//       } else if (!error.message?.includes('404')) {
//         ToastService.error('Failed to load credit data. Please try again.');
//       }
//     } finally {
//       setLoading(prev => ({ ...prev, collections: false }));
//     }
//   };
//
//   const handleSearch = (e) => {
//     setSearchTerm(e.target.value);
//     setPagination(prev => ({ ...prev, currentPage: 1 }));
//   };
//
//   const handleDateChange = (e) => {
//     const { name, value } = e.target;
//     setDateRange(prev => ({ ...prev, [name]: value }));
//     setPagination(prev => ({ ...prev, currentPage: 1 }));
//   };
//
//   const handleClearFilters = () => {
//     setSearchTerm('');
//     setDateRange({ startDate: '', endDate: '' });
//     setPagination(prev => ({ ...prev, currentPage: 1 }));
//   };
//
//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= pagination.totalPages) {
//       setPagination(prev => ({ ...prev, currentPage: page }));
//     }
//   };
//
//   const formatCurrency = (amount) => {
//     if (amount === undefined || amount === null) return 'Rs.0.00';
//     const num = Number(amount);
//     return `Rs.${num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
//   };
//
//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//
//     try {
//       const date = new Date(dateString);
//       return date.toLocaleDateString('en-US', {
//         month: 'short',
//         day: 'numeric',
//         year: 'numeric'
//       });
//     } catch (error) {
//       return 'Invalid date';
//     }
//   };
//
//   const getPaymentStatus = (collection) => {
//     const status = collection.status || 'PENDING';
//
//     switch (status) {
//       case 'PAID': return 'Paid';
//       case 'PENDING': return 'Pending';
//       case 'OVERDUE': return 'Overdue';
//       case 'PARTIALLY_PAID': return 'Partial';
//       default: return status;
//     }
//   };
//
//   const getStatusColor = (status) => {
//     switch (status) {
//       case 'Paid': return 'status-success';
//       case 'Partial': return 'status-warning';
//       case 'Pending': return 'status-warning';
//       case 'Overdue': return 'status-danger';
//       default: return 'status-inactive';
//     }
//   };
//
//   const handleOpenPaymentModal = (collection) => {
//     if (!shiftActive) {
//       ToastService.error('Please start a shift first to manage credit payments.', 'error', 3000);
//       return;
//     }
//
//     setSelectedCollection(collection);
//     setShowPaymentModal(true);
//
//     // Pre-fill the amount with the collection amount
//     setPaymentForm(prev => ({
//       ...prev,
//       amount: collection.amount || ''
//     }));
//
//     setPaymentMethods([]);
//   };
//
//   const resetPaymentForm = () => {
//     setPaymentForm({
//       method: 'CASH',
//       amount: selectedCollection?.amount || '',
//       notes: '',
//       chequeNumber: '',
//       bank: '',
//       chequeDate: '',
//       reference: ''
//     });
//   };
//
//   const handlePaymentFormChange = (e) => {
//     const { name, value } = e.target;
//     setPaymentForm(prev => ({ ...prev, [name]: value }));
//   };
//
//   const handleAddPaymentMethod = () => {
//     const amount = parseFloat(paymentForm.amount);
//
//     if (!amount || amount <= 0) {
//       ToastService.error('Please enter a valid amount.', 'error', 3000);
//       return;
//     }
//
//     if (!selectedCollection) {
//       ToastService.error('Collection information is not available.', 'error', 3000);
//       return;
//     }
//
//     const collectionAmount = selectedCollection.amount || 0;
//     const totalCollected = paymentMethods.reduce((sum, p) => sum + p.amount, 0);
//     const remainingBalance = collectionAmount - totalCollected;
//
//     if (amount > remainingBalance) {
//       ToastService.error(`Amount exceeds remaining balance of ${formatCurrency(remainingBalance)}`, 'error', 3000);
//       return;
//     }
//
//     // Validate payment method specific fields
//     if (paymentForm.method === 'CHEQUE') {
//       if (!paymentForm.chequeNumber || !paymentForm.bank || !paymentForm.chequeDate) {
//         ToastService.error('Cheque number, bank, and cheque date are required for cheque payments.', 'error', 3000);
//         return;
//       }
//     }
//
//     if (paymentForm.method === 'BANK_TRANSFER' || paymentForm.method === 'CARD') {
//       if (!paymentForm.reference) {
//         ToastService.error('Reference number is required for bank transfers and card payments.', 'error', 3000);
//         return;
//       }
//     }
//
//     const newPaymentMethod = {
//       method: paymentForm.method,
//       amount: amount,
//       notes: paymentForm.notes || '',
//       chequeNumber: paymentForm.chequeNumber || '',
//       bank: paymentForm.bank || '',
//       chequeDate: paymentForm.chequeDate || '',
//       reference: paymentForm.reference || '',
//       collectionId: selectedCollection.id
//     };
//
//     setPaymentMethods(prev => [...prev, newPaymentMethod]);
//     resetPaymentForm();
//   };
//
//   const handleRemovePaymentMethod = (index) => {
//     setPaymentMethods(prev => prev.filter((_, i) => i !== index));
//   };
//
//   const handleResetPaymentMethods = () => {
//     setPaymentMethods([]);
//     resetPaymentForm();
//   };
//
//   const getTotalCollected = () => {
//     return paymentMethods.reduce((sum, payment) => sum + payment.amount, 0);
//   };
//
//   const getRemainingBalance = () => {
//     if (!selectedCollection) return 0;
//     const collectionAmount = selectedCollection.amount || 0;
//     return collectionAmount - getTotalCollected();
//   };
//
//   const handleSubmitPayment = async () => {
//     const totalCollected = getTotalCollected();
//
//     if (totalCollected <= 0) {
//       ToastService.error('Please add at least one payment method.', 'error', 3000);
//       return;
//     }
//
//     if (!selectedCollection) {
//       ToastService.error('No collection selected.', 'error', 3000);
//       return;
//     }
//
//     const invId = await ShiftService.getActiveInventoryId();
//
//     // Prepare payment data
//     const paymentData = {
//       collectionId: selectedCollection.id,
//       creditId: selectedCollection.credit?.id,
//       inventoryId: invId,
//       totalAmount: totalCollected,
//       notes: paymentMethods.map(p => p.notes).filter(n => n).join(', ') || 'Credit payment',
//       paymentMethods: paymentMethods.map(payment => ({
//         method: payment.method,
//         amount: payment.amount,
//         notes: payment.notes || '',
//         ...(payment.method === 'CHEQUE' && {
//           chequeNumber: payment.chequeNumber,
//           bank: payment.bank,
//           chequeDate: payment.chequeDate
//         }),
//         ...((payment.method === 'BANK_TRANSFER' || payment.method === 'CARD') && {
//           reference: payment.reference
//         })
//       }))
//     };
//
//     try {
//       setLoading(prev => ({ ...prev, submitting: true }));
//
//       const response = await CreditService.processCreditPayment(paymentData);
//
//       if (response.success) {
//         ToastService.success(`Payment of ${formatCurrency(totalCollected)} recorded successfully!`, 'success', 3000);
//         try {
//           await printCollectionReceipt();
//         } catch (printError) {
//           console.error('Receipt printing failed:', printError);
//           // Don't fail the payment if printing fails
//           ToastService.warning('Payment recorded but receipt printing failed', 'warning', 2000);
//         }
//         setShowPaymentModal(false);
//         setSelectedCollection(null);
//         setPaymentMethods([]);
//         fetchCollections(); // Refresh the list
//       } else {
//         ToastService.error(response.message || 'Failed to record payment.', 'error', 3000);
//       }
//     } catch (error) {
//       ToastService.error(error.message || 'Failed to record payment.', 'error', 3000);
//     } finally {
//       setLoading(prev => ({ ...prev, submitting: false }));
//     }
//   };
//
//   const handleStartShift = () => {
//     navigate('/dashboard');
//     ToastService.info('Please start a shift first to manage credit payments.', 'info', 3000);
//   };
//
//   // Helper to show/hide payment method specific fields
//   const showChequeFields = paymentForm.method === 'CHEQUE';
//   const showReferenceField = paymentForm.method === 'BANK_TRANSFER' || paymentForm.method === 'CARD';
//
//   return (
//     <div className="credit-page">
//       <Sidebar isOpen={showSidebar} onClose={() => setShowSidebar(false)} />
//
//       {showSidebar && (
//         <div
//           className="sidebar-overlay active"
//           onClick={() => setShowSidebar(false)}
//         />
//       )}
//
//       <header className="header">
//         <div className="header-content">
//           <div className="header-left">
//             <button className="icon-btn" onClick={() => setShowSidebar(true)}>
//               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <line x1="3" y1="12" x2="21" y2="12"></line>
//                 <line x1="3" y1="6" x2="21" y2="6"></line>
//                 <line x1="3" y1="18" x2="21" y2="18"></line>
//               </svg>
//             </button>
//             <div className="header-title">Credit Collections</div>
//           </div>
//         </div>
//       </header>
//
//       <div className="container">
//         <div className="card">
//           <div className="table-controls">
//             <div className="title-and-actions">
//               <h2 className="card-title">
//                 Credit Collections
//                 {routeInfo && (
//                   <span className="route-badge">
//                     <i className="fas fa-route"></i>
//                     {routeInfo.name}
//                   </span>
//                 )}
//               </h2>
//               <button
//                 className="btn-clear-filters"
//                 onClick={handleClearFilters}
//                 disabled={!shiftActive || loading.collections}
//               >
//                 Clear Filters
//               </button>
//             </div>
//
//             <div className="filters-group">
//               <div className="date-filter-group">
//                 <div className="date-input-pair">
//                   <label htmlFor="startDate">Start Date:</label>
//                   <input
//                     type="date"
//                     id="startDate"
//                     name="startDate"
//                     className="form-input"
//                     value={dateRange.startDate}
//                     onChange={handleDateChange}
//                     disabled={!shiftActive || loading.collections}
//                   />
//                 </div>
//                 <div className="date-input-pair">
//                   <label htmlFor="endDate">End Date:</label>
//                   <input
//                     type="date"
//                     id="endDate"
//                     name="endDate"
//                     className="form-input"
//                     value={dateRange.endDate}
//                     onChange={handleDateChange}
//                     disabled={!shiftActive || loading.collections}
//                   />
//                 </div>
//               </div>
//
//               <div className="search-box">
//                 <input
//                   type="text"
//                   className="form-input"
//                   placeholder="Search by collection code, customer name, or ID..."
//                   value={searchTerm}
//                   onChange={handleSearch}
//                   disabled={!shiftActive || loading.collections}
//                 />
//                 <i className="fas fa-search search-icon"></i>
//               </div>
//             </div>
//           </div>
//
//           {!shiftActive ? (
//             <div className="shift-required-state">
//               <i className="fas fa-clock"></i>
//               <h3>Shift Not Started</h3>
//               <p>You need to start a shift first to manage credit collections.</p>
//               <button className="btn-start-shift" onClick={handleStartShift}>
//                 <i className="fas fa-play-circle"></i>
//                 Go to Dashboard to Start Shift
//               </button>
//             </div>
//           ) : loading.collections ? (
//             <div className="loading-state">
//               <div className="loading-spinner"></div>
//               <p>Loading credit collections...</p>
//             </div>
//           ) : (
//             <>
//               <div className="data-table-container">
//                 <table className="credit-table">
//                   <thead>
//                     <tr>
//                       <th>ID</th>
//                       <th>Collection Code</th>
//                       <th>Customer</th>
//                       <th>Credit Amount (Rs.)</th>
//                       <th>Collection Amount (Rs.)</th>
//                       <th>Remaining Amount (Rs.)</th>
//                       <th>Status</th>
//                       <th>Created Date</th>
//                       <th>Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {collections.length > 0 ? (
//                       collections.map((collection) => {
//                         const status = getPaymentStatus(collection);
//                         const collectionAmount = collection.amount || 0;
//                         const creditAmount = collection.credit?.amount || 0;
//                         const remainingAmount = collection.credit?.remainingAmount || 0;
//                         const code = collection.code || `COL-${String(collection.id).padStart(6, '0')}`;
//                         const customerName = collection.credit?.customer?.name || 'N/A';
//                         const customerId = collection.credit?.customer?.id || 'N/A';
//                         const creditStatus = collection.credit?.status || 'N/A';
//
//                         return (
//                           <tr key={collection.id}>
//                             <td>{collection.id}</td>
//                             <td>
//                               <strong>{code}</strong>
//                             </td>
//                             <td>
//                               <div className="customer-info">
//                                 <div className="customer-name">{customerName}</div>
//                                 {customerId && customerId !== 'N/A' && (
//                                   <div className="customer-id">ID: {customerId}</div>
//                                 )}
//                               </div>
//                             </td>
//                             <td className="amount-cell">{formatCurrency(creditAmount)}</td>
//                             <td className="amount-cell">{formatCurrency(collectionAmount)}</td>
//                             <td className="amount-cell">{formatCurrency(remainingAmount)}</td>
//                             <td>
//                               <div className="status-container">
//                                 <span className={`status-badge ${getStatusColor(status)}`}>
//                                   {status}
//                                 </span>
//                                 {creditStatus && creditStatus !== 'N/A' && creditStatus !== status && (
//                                   <div className="credit-status-info">
//                                     <small>Credit: {creditStatus}</small>
//                                   </div>
//                                 )}
//                               </div>
//                             </td>
//                             <td>{formatDate(collection.createdAt)}</td>
//                             <td>
//                               <button
//                                 className="action-button"
//                                 onClick={() => handleOpenPaymentModal(collection)}
//                                 disabled={loading.submitting || collection.status === 'PAID'}
//                                 title={collection.status === 'PAID' ? 'Already Paid' : 'Collect Payment'}
//                               >
//                                 {collection.status === 'PAID' ? (
//                                   <>
//                                     <i className="fas fa-check-circle"></i> Paid
//                                   </>
//                                 ) : (
//                                   <>
//                                     <i className="fas fa-money-bill-wave"></i> Collect
//                                   </>
//                                 )}
//                               </button>
//                             </td>
//                           </tr>
//                         );
//                       })
//                     ) : (
//                       <tr>
//                         <td colSpan="9" className="empty-table">
//                           {searchTerm || dateRange.startDate || dateRange.endDate ? (
//                             <>
//                               <i className="fas fa-search"></i>
//                               <p>No collections found matching your filters</p>
//                             </>
//                           ) : (
//                             <>
//                               <i className="fas fa-hand-holding-dollar"></i>
//                               <p>No credit collections found</p>
//                             </>
//                           )}
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//
//               {pagination.totalPages > 1 && (
//                 <div className="pagination-controls">
//                   <button
//                     className="pagination-btn"
//                     onClick={() => handlePageChange(pagination.currentPage - 1)}
//                     disabled={!pagination.hasPrevPage || loading.collections}
//                   >
//                     <i className="fas fa-chevron-left"></i> Previous
//                   </button>
//
//                   <div className="page-info">
//                     Page {pagination.currentPage} of {pagination.totalPages}
//                     {pagination.total > 0 && (
//                       <span className="total-items"> ({pagination.total} collections)</span>
//                     )}
//                   </div>
//
//                   <button
//                     className="pagination-btn"
//                     onClick={() => handlePageChange(pagination.currentPage + 1)}
//                     disabled={!pagination.hasNextPage || loading.collections}
//                   >
//                     Next <i className="fas fa-chevron-right"></i>
//                   </button>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//
//       {/* Payment Recording Modal */}
//       {showPaymentModal && selectedCollection && (
//         <div className="modal active">
//           <div className="modal-content">
//             <div className="modal-header">
//               Credit Collection Payment - {selectedCollection.code || `Collection ${selectedCollection.id}`}
//               <button
//                 className="modal-close-btn"
//                 onClick={() => {
//                   setShowPaymentModal(false);
//                   setSelectedCollection(null);
//                   setPaymentMethods([]);
//                 }}
//                 disabled={loading.submitting}
//               >
//                 &times;
//               </button>
//             </div>
//
//             <div className="modal-body">
//               <div className="collection-info-section">
//                 <div className="info-row">
//                   <span className="info-label">Collection Code:</span>
//                   <span className="info-value">{selectedCollection.code || `COL-${String(selectedCollection.id).padStart(6, '0')}`}</span>
//                 </div>
//                 <div className="info-row">
//                   <span className="info-label">Customer:</span>
//                   <span className="info-value">
//                     {selectedCollection.credit?.customer?.name || 'N/A'}
//                     {selectedCollection.credit?.customer?.id && ` (ID: ${selectedCollection.credit.customer.id})`}
//                   </span>
//                 </div>
//                 <div className="info-row">
//                   <span className="info-label">Original Credit Amount:</span>
//                   <span className="info-value">{formatCurrency(selectedCollection.credit?.amount || 0)}</span>
//                 </div>
//                 <div className="info-row">
//                   <span className="info-label">Remaining Credit Balance:</span>
//                   <span className="info-value">{formatCurrency(selectedCollection.credit?.remainingAmount || 0)}</span>
//                 </div>
//                 <div className="info-row">
//                   <span className="info-label">Collection Amount:</span>
//                   <span className="info-value balance-display">
//                     {formatCurrency(selectedCollection.amount || 0)}
//                   </span>
//                 </div>
//                 <div className="info-row">
//                   <span className="info-label">Collection Status:</span>
//                   <span className="info-value">
//                     <span className={`status-badge ${getStatusColor(getPaymentStatus(selectedCollection))}`}>
//                       {getPaymentStatus(selectedCollection)}
//                     </span>
//                   </span>
//                 </div>
//                 <div className="info-row">
//                   <span className="info-label">Credit Status:</span>
//                   <span className="info-value">
//                     <span className={`status-badge ${getStatusColor(selectedCollection.credit?.status || 'N/A')}`}>
//                       {selectedCollection.credit?.status || 'N/A'}
//                     </span>
//                   </span>
//                 </div>
//               </div>
//
//               <div className="payment-form-section">
//                 <h4>Add Payment Method</h4>
//
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label htmlFor="method">Payment Method *</label>
//                     <select
//                       id="method"
//                       name="method"
//                       className="form-input-control"
//                       value={paymentForm.method}
//                       onChange={handlePaymentFormChange}
//                       disabled={loading.submitting}
//                     >
//                       <option value="CASH">Cash</option>
//                       <option value="CHEQUE">Cheque</option>
//                       <option value="BANK_TRANSFER">Bank Transfer</option>
//                       <option value="CARD">Card</option>
//                     </select>
//                   </div>
//
//                   <div className="form-group">
//                     <label htmlFor="amount">Amount *</label>
//                     <input
//                       type="number"
//                       id="amount"
//                       name="amount"
//                       className="form-input-control"
//                       value={paymentForm.amount}
//                       onChange={handlePaymentFormChange}
//                       min="1"
//                       max={getRemainingBalance()}
//                       placeholder="Enter amount"
//                       disabled={loading.submitting}
//                     />
//                     <small className="hint">Max: {formatCurrency(getRemainingBalance())}</small>
//                   </div>
//                 </div>
//
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label htmlFor="notes">Notes</label>
//                     <input
//                       type="text"
//                       id="notes"
//                       name="notes"
//                       className="form-input-control"
//                       value={paymentForm.notes}
//                       onChange={handlePaymentFormChange}
//                       placeholder="Optional notes"
//                       disabled={loading.submitting}
//                     />
//                   </div>
//                 </div>
//
//                 {/* Cheque specific fields */}
//                 {showChequeFields && (
//                   <div className="form-row">
//                     <div className="form-group">
//                       <label htmlFor="chequeNumber">Cheque Number *</label>
//                       <input
//                         type="text"
//                         id="chequeNumber"
//                         name="chequeNumber"
//                         className="form-input-control"
//                         value={paymentForm.chequeNumber}
//                         onChange={handlePaymentFormChange}
//                         placeholder="Enter cheque number"
//                         disabled={loading.submitting}
//                       />
//                     </div>
//
//                     <div className="form-group">
//                       <label htmlFor="bank">Bank *</label>
//                       <input
//                         type="text"
//                         id="bank"
//                         name="bank"
//                         className="form-input-control"
//                         value={paymentForm.bank}
//                         onChange={handlePaymentFormChange}
//                         placeholder="Bank name"
//                         disabled={loading.submitting}
//                       />
//                     </div>
//
//                     <div className="form-group">
//                       <label htmlFor="chequeDate">Cheque Date *</label>
//                       <input
//                         type="date"
//                         id="chequeDate"
//                         name="chequeDate"
//                         className="form-input-control"
//                         value={paymentForm.chequeDate}
//                         onChange={handlePaymentFormChange}
//                         disabled={loading.submitting}
//                       />
//                     </div>
//                   </div>
//                 )}
//
//                 {/* Reference field for Bank Transfer and Card */}
//                 {showReferenceField && (
//                   <div className="form-row">
//                     <div className="form-group">
//                       <label htmlFor="reference">Reference Number *</label>
//                       <input
//                         type="text"
//                         id="reference"
//                         name="reference"
//                         className="form-input-control"
//                         value={paymentForm.reference}
//                         onChange={handlePaymentFormChange}
//                         placeholder="Enter reference number"
//                         disabled={loading.submitting}
//                       />
//                     </div>
//                   </div>
//                 )}
//
//                 <button
//                   className="btn-add-payment"
//                   onClick={handleAddPaymentMethod}
//                   disabled={loading.submitting || getRemainingBalance() <= 0}
//                 >
//                   <i className="fas fa-plus"></i> Add Payment Method
//                 </button>
//               </div>
//
//               <div className="collections-recorded-area">
//                 <h4>Payment Methods Added</h4>
//                 {paymentMethods.length === 0 ? (
//                   <div className="no-payments">
//                     <i className="fas fa-money-bill-wave"></i>
//                     <p>No payment methods added yet</p>
//                   </div>
//                 ) : (
//                   <table className="collections-table">
//                     <thead>
//                       <tr>
//                         <th>Method</th>
//                         <th>Amount</th>
//                         <th>Details</th>
//                         <th></th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {paymentMethods.map((payment, index) => (
//                         <tr key={index}>
//                           <td>{payment.method}</td>
//                           <td>{formatCurrency(payment.amount)}</td>
//                           <td>
//                             {payment.method === 'CHEQUE' && (
//                               <div>
//                                 <small>{payment.chequeNumber} - {payment.bank}</small>
//                               </div>
//                             )}
//                             {(payment.method === 'BANK_TRANSFER' || payment.method === 'CARD') && (
//                               <div>
//                                 <small>Ref: {payment.reference}</small>
//                               </div>
//                             )}
//                             {payment.notes && (
//                               <div>
//                                 <small>Note: {payment.notes}</small>
//                               </div>
//                             )}
//                           </td>
//                           <td>
//                             <button
//                               className="remove-btn"
//                               onClick={() => handleRemovePaymentMethod(index)}
//                               disabled={loading.submitting}
//                             >
//                               ✕
//                             </button>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 )}
//               </div>
//
//               <div className="summary-row total-collected">
//                 <span>Total Payment:</span>
//                 <span>{formatCurrency(getTotalCollected())}</span>
//               </div>
//
//               <div className="summary-row balance">
//                 <span>Remaining Balance:</span>
//                 <span>{formatCurrency(getRemainingBalance())}</span>
//               </div>
//             </div>
//
//             <div className="modal-footer">
//               <button
//                 className="btn-reset"
//                 onClick={handleResetPaymentMethods}
//                 disabled={loading.submitting || paymentMethods.length === 0}
//               >
//                 Reset Payments
//               </button>
//
//               <button
//                 className="btn-confirm"
//                 onClick={handleSubmitPayment}
//                 disabled={loading.submitting || getTotalCollected() <= 0}
//               >
//                 {loading.submitting ? (
//                   <>
//                     <i className="fas fa-spinner fa-spin"></i> Processing...
//                   </>
//                 ) : (
//                   <>
//                     <i className="fas fa-check-circle"></i> Submit Payment
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
//
// export default Credit;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EscPosEncoder from 'esc-pos-encoder';
import { usePrinter } from '../../context/PrinterContext';
import authService from '../../services/authService';
import CreditService from '../../services/creditService';
import ToastService from '../../services/toastService';
import ShiftService from '../../services/shiftService';
import Sidebar from '../Sidebar/Sidebar';

const Credit = () => {
  const { characteristic } = usePrinter();
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState({
    collections: false,
    submitting: false
  });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    total: 0,
    limit: 10
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [routeInfo, setRouteInfo] = useState(null);
  const [shiftActive, setShiftActive] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: '',
    endDate: ''
  });

  // Modal states
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState(null);

  // Payment form state
  const [paymentForm, setPaymentForm] = useState({
    method: 'CASH',
    amount: '',
    notes: '',
    chequeNumber: '',
    bank: '',
    chequeDate: '',
    reference: ''
  });

  const [paymentMethods, setPaymentMethods] = useState([]);

  useEffect(() => {
    // Check authentication
    if (!authService.isAuthenticated()) {
      ToastService.error('Session expired. Please login again.');
      navigate('/login');
      return;
    }

    // Check if shift is active and get routeId
    checkShiftStatus();
  }, [navigate]);

  const generateCollectionReceipt = async ({
                                             collection,
                                             paymentMethods,
                                             totals,
                                             currentUser,
                                             customerData,
                                             routeInfo
                                           }) => {
    const encoder = new EscPosEncoder();

    // Extract data
    const invoiceNum = collection.code || `COL-${String(collection.id).padStart(6, '0')}`;
    const paymentBatchCode = collection.paymentBatchCode || invoiceNum;
    const currentTime = new Date().toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
    const currentDate = new Date().toLocaleDateString('en-GB');

    // Business information;

     const businessName = "         Sayul Redistributions";
  const businessAddress =  "NO 244/2/A.Makola, North, Makola";
  const businessPhone = "Tel: +94 77 222 2700";

    // Customer data
    const customerName = customerData?.name || "Customer";
    const customerCode = customerData?.code || "N/A";
    const salesRep = currentUser?.firstName || "Sales Rep";
    const routeName = routeInfo?.name || "Route";

    // Get inventory info
    const shiftDataStr = localStorage.getItem('current_shift');
    let inventoryName = "Main Inventory";
    if (shiftDataStr) {
      const shiftData = JSON.parse(shiftDataStr);
      inventoryName = shiftData.inventoryName || inventoryName;
    }

    // Payment totals
    const totalAmount = totals.totalAmount || 0;
    const paidAmount = totals.paidAmount || 0;
    const remainingBalance = totals.remainingBalance || 0;
    const isFullyPaid = remainingBalance <= 0;

    // Build the receipt
    const receipt = encoder
        .initialize()
        .codepage('cp858')

        // ==================== BUSINESS HEADER ====================
        .align('center')
        .size(2, 2)
        .bold(true)
        .line(businessName)
        .size(1, 1)
        .bold(false)
        .line(businessAddress)
        .line(businessPhone)
        .line('='.repeat(42))

        // ==================== COLLECTION RECEIPT HEADER ====================
        .align('center')
        .size('double')
        .bold(true)
        .line('COLLECTION RECEIPT')
        .size('normal')
        .bold(false)
        .line('='.repeat(42))

        // ==================== COLLECTION DETAILS ====================
        .align('left')
        .bold(true)
        .line('COLLECTION DETAILS')
        .bold(false)
        .line('='.repeat(42))
        .line(`Receipt #  : ${invoiceNum}`)
        .line(`Batch Code : ${paymentBatchCode}`)
        .line(`Date/Time  : ${currentDate} ${currentTime}`)
        .line(`Customer   : ${customerName.substring(0, 20)}`)
        .line(`Cust Code  : ${customerCode.substring(0, 15)}`)
        .line(`Sales Rep  : ${salesRep.substring(0, 15)}`)
        .line(`Route      : ${routeName.substring(0, 15)}`)
        .line(`Inventory  : ${inventoryName.substring(0, 15)}`)
        .line('='.repeat(42))

        // ==================== ORIGINAL CREDIT INFO ====================
        .align('left')
        .bold(true)
        .line('ORIGINAL CREDIT')
        .bold(false)
        .line('─'.repeat(42))
        .line(`Collection Code : ${invoiceNum}`)
        .line(`Credit Amount   : Rs.${totalAmount.toFixed(2).padStart(10)}`)
        .line('='.repeat(42));

    // ==================== PAYMENT METHODS SECTION ====================
    receipt
        .align('left')
        .bold(true)
        .line('PAYMENT DETAILS')
        .bold(false)
        .line('='.repeat(42));

    if (paymentMethods && paymentMethods.length > 0) {
      // Table header for payments
      receipt
          .align('center')
          .bold(true)
          .line('Method        Amount')
          .bold(false)
          .line('='.repeat(42));

      // Print each payment method
      paymentMethods.forEach(payment => {
        const method = (payment.method || 'CASH').substring(0, 12).padEnd(12);
        const amount = (payment.amount || 0).toFixed(2).padStart(10);
        receipt.line(`${method}Rs.${amount}`);

        // Show payment details if available
        if (payment.chequeNumber) {
          receipt.line(`  Cheque: ${payment.chequeNumber}`);
        }
        if (payment.bank) {
          receipt.line(`  Bank: ${payment.bank}`);
        }
        if (payment.reference) {
          receipt.line(`  Ref: ${payment.reference}`);
        }
        if (payment.notes) {
          receipt.line(`  Note: ${payment.notes.substring(0, 35)}`);
        }
        receipt.line('='.repeat(42));
      });
    } else {
      receipt.line('No payment methods recorded');
      receipt.line('='.repeat(42));
    }

    // ==================== SUMMARY SECTION ====================
    receipt
        .align('right')
        .bold(true)
        .line('SUMMARY')
        .bold(false)
        .line('='.repeat(42))
        .line(`Credit Amount   : Rs.${totalAmount.toFixed(2).padStart(10)}`)
        .line(`Amount Paid     : Rs.${paidAmount.toFixed(2).padStart(10)}`)
        .line('='.repeat(42));

    // Calculate remaining balance
    const balance = totalAmount - paidAmount;

    if (balance > 0) {
      receipt
          .bold(true)
          .line(`Balance Due     : Rs.${balance.toFixed(2).padStart(10)}`)
          .bold(false);
    } else {
      receipt
          .bold(true)
          .size('double')
          .line('─'.repeat(42))
          .line('FULLY PAID')
          .size('normal')
          .line('='.repeat(42))
          .bold(false);
    }

    receipt.line('='.repeat(42));

    // ==================== PAYMENT STATUS ====================
    receipt
        .align('center')
        .bold(true);

    if (isFullyPaid) {
      receipt
          .size('double')
          .line('PAYMENT COMPLETE')
          .size('normal');
    } else if (paidAmount > 0) {
      receipt
          .line('PARTIAL PAYMENT RECEIVED');
    } else {
      receipt
          .line('NO PAYMENT RECORDED');
    }

    receipt.bold(false);

    // ==================== FOOTER ====================
    receipt
        .line('='.repeat(42))
        .line(' ')
        .align('center')
        .bold(true)
        .line('THANK YOU FOR YOUR PAYMENT!')
        .bold(false)
        .line('We appreciate your business')
        .line('Please keep this receipt for your records')
        .line(' ')
        .size(1, 1)
        .line('software by @fidesm.dev | +94 75 718 0225')
        .newline()
        .cut('partial');

    // ENCODE the receipt
    const encodedData = receipt.encode();

    console.log('Collection receipt generated for:', invoiceNum);
    return encodedData;
  };

  const printCollectionReceipt = async () => {
    try {
      if (!characteristic || !characteristic.writeValue) {
        ToastService.error('Printer not connected. Please connect a printer first.', 'error', 3000);
        return;
      }

      // Get current user
      const currentUser = authService.getCurrentUser();

      // Prepare customer data from selected collection
      let customerData = {};

      // Try to get customer info from collection data
      if (selectedCollection?.credit?.customer) {
        customerData = {
          name: selectedCollection.credit.customer.name || "Customer",
          code: `CUST-${String(selectedCollection.credit.customer.id).padStart(6, '0')}`
        };
      } else {
        // Fallback to dummy data
        customerData = {
          name: "Customer",
          code: "CUST"
        };
      }

      // Prepare data for receipt
      const receiptData = {
        collection: selectedCollection,
        paymentMethods: paymentMethods,
        totals: {
          totalAmount: selectedCollection?.amount || 0,
          paidAmount: getTotalCollected(),
          remainingBalance: getRemainingBalance()
        },
        currentUser: currentUser,
        customerData: customerData,
        routeInfo: routeInfo
      };

      // Generate receipt
      const receipt = await generateCollectionReceipt(receiptData);

      // Print the receipt in chunks
      const CHUNK_SIZE = 100;
      const totalBytes = receipt.byteLength;
      let offset = 0;

      console.log(`Writing receipt (${totalBytes} bytes) in ${CHUNK_SIZE} byte chunks...`);

      while (offset < totalBytes) {
        const chunkSize = Math.min(CHUNK_SIZE, totalBytes - offset);
        const chunk = receipt.slice(offset, offset + chunkSize);

        // Send the chunk
        await characteristic.writeValue(chunk);

        // Delay between chunks
        await new Promise(resolve => setTimeout(resolve, 100));

        offset += chunkSize;
      }

      console.log('Collection receipt printed successfully!');
      ToastService.success('Receipt printed successfully!', 'success', 2000);

    } catch (error) {
      console.error('Error printing receipt:', error);
      ToastService.error('Failed to print receipt: ' + error.message, 'error', 3000);
    }
  };

  useEffect(() => {
    if (shiftActive && routeInfo?.id) {
      fetchCollections();
    }
  }, [shiftActive, routeInfo?.id, pagination.currentPage, searchTerm, dateRange]);

  const checkShiftStatus = () => {
    const shiftDataStr = localStorage.getItem('current_shift');

    if (shiftDataStr) {
      const shiftData = JSON.parse(shiftDataStr);

      if (shiftData.isActive && shiftData.routeId) {
        setShiftActive(true);
        setRouteInfo({
          id: shiftData.routeId,
          name: shiftData.routeName || 'Current Route'
        });

        const routeName = localStorage.getItem('currentRouteName');
        if (routeName) {
          setRouteInfo(prev => ({ ...prev, name: routeName }));
        }
      } else {
        setShiftActive(false);
        setRouteInfo(null);
      }
    } else {
      setShiftActive(false);
      setRouteInfo(null);
    }

    setLoading({ collections: false, submitting: false });
  };

  const fetchCollections = async () => {
    try {
      setLoading(prev => ({ ...prev, collections: true }));

      // Use the direct method to get collections
      const response = await CreditService.getCollectionsDirect({
        routeId: routeInfo.id
      });

      console.log('Direct collections response:', response);

      let collectionsData = [];

      if (response.success && response.data) {
        if (Array.isArray(response.data.collections)) {
          collectionsData = response.data.collections;
        } else if (Array.isArray(response.data.customers)) {
          collectionsData = response.data.customers;
        } else if (Array.isArray(response.data)) {
          collectionsData = response.data;
        }
      }

      console.log('Extracted collections data:', collectionsData);

      // Apply search filter
      if (searchTerm) {
        const lowerCaseSearch = searchTerm.toLowerCase();
        collectionsData = collectionsData.filter(collection =>
            collection.code?.toLowerCase().includes(lowerCaseSearch) ||
            (collection.id?.toString() || '').includes(lowerCaseSearch) ||
            collection.credit?.customer?.name?.toLowerCase().includes(lowerCaseSearch) ||
            (collection.credit?.customer?.id?.toString() || '').includes(lowerCaseSearch)
        );
      }

      // Apply date filter
      if (dateRange.startDate || dateRange.endDate) {
        collectionsData = collectionsData.filter(collection => {
          if (!collection.createdAt) return true;

          const creditDate = new Date(collection.createdAt);
          const startDate = dateRange.startDate ? new Date(dateRange.startDate) : null;
          const endDate = dateRange.endDate ? new Date(dateRange.endDate) : null;

          let isInRange = true;
          if (startDate && creditDate < startDate) isInRange = false;
          if (endDate) {
            const endOfDay = new Date(endDate);
            endOfDay.setHours(23, 59, 59, 999);
            if (creditDate > endOfDay) isInRange = false;
          }

          return isInRange;
        });
      }

      // Calculate pagination
      const total = collectionsData.length;
      const totalPages = Math.ceil(total / pagination.limit);
      const startIndex = (pagination.currentPage - 1) * pagination.limit;
      const endIndex = startIndex + pagination.limit;

      const paginatedData = collectionsData.slice(startIndex, endIndex);

      console.log('Setting collections to display:', paginatedData);

      setCollections(paginatedData);
      setPagination(prev => ({
        ...prev,
        totalPages,
        total,
        hasNextPage: pagination.currentPage < totalPages,
        hasPrevPage: pagination.currentPage > 1
      }));

    } catch (error) {
      console.error('Error fetching collections:', error);
      setCollections([]);
      setPagination(prev => ({
        ...prev,
        totalPages: 0,
        total: 0,
        hasNextPage: false,
        hasPrevPage: false
      }));

      if (error.message?.includes('401') || error.message?.includes('Session expired')) {
        ToastService.error('Session expired. Please login again.');
        navigate('/login');
      } else if (!error.message?.includes('404')) {
        ToastService.error('Failed to load credit data. Please try again.');
      }
    } finally {
      setLoading(prev => ({ ...prev, collections: false }));
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setPagination(prev => ({ ...prev, currentPage: 1 }));
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDateRange(prev => ({ ...prev, [name]: value }));
    setPagination(prev => ({ ...prev, currentPage: 1 }));
  };

  const handleClearFilters = () => {
    setSearchTerm('');
    setDateRange({ startDate: '', endDate: '' });
    setPagination(prev => ({ ...prev, currentPage: 1 }));
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= pagination.totalPages) {
      setPagination(prev => ({ ...prev, currentPage: page }));
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const formatCurrency = (amount) => {
    if (amount === undefined || amount === null) return 'Rs.0.00';
    const num = Number(amount);
    return `Rs.${num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';

    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    } catch (error) {
      return 'Invalid date';
    }
  };

  const getPaymentStatus = (collection) => {
    const status = collection.status || 'PENDING';

    switch (status) {
      case 'PAID': return 'Paid';
      case 'PENDING': return 'Pending';
      case 'OVERDUE': return 'Overdue';
      case 'PARTIALLY_PAID': return 'Partial';
      default: return status;
    }
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'Paid': 'bg-green-100 text-green-700',
      'Partial': 'bg-yellow-100 text-yellow-700',
      'Pending': 'bg-blue-100 text-blue-700',
      'Overdue': 'bg-red-100 text-red-700'
    };

    return statusMap[status] || 'bg-gray-100 text-gray-700';
  };

  const handleOpenPaymentModal = (collection) => {
    if (!shiftActive) {
      ToastService.error('Please start a shift first to manage credit payments.', 'error', 3000);
      return;
    }

    setSelectedCollection(collection);
    setShowPaymentModal(true);

    // Pre-fill the amount with the collection amount
    setPaymentForm(prev => ({
      ...prev,
      // amount: collection.amount || ''
        amount: collection.credit?.remainingAmount || collection.amount || ''
    }));

    setPaymentMethods([]);
  };

  // const resetPaymentForm = () => {
  //   setPaymentForm({
  //     method: 'CASH',
  //     amount: selectedCollection?.amount || '',
  //     notes: '',
  //     chequeNumber: '',
  //     bank: '',
  //     chequeDate: '',
  //     reference: ''
  //   });
  // };

  const resetPaymentForm = () => {
    const remaining = (selectedCollection?.credit?.remainingAmount || selectedCollection?.amount || 0)
      - paymentMethods.reduce((sum, p) => sum + p.amount, 0);
    setPaymentForm({
      method: 'CASH',
      amount: remaining > 0 ? remaining : '',
      notes: '',
      chequeNumber: '',
      bank: '',
      chequeDate: '',
      reference: ''
    });
};

  const handlePaymentFormChange = (e) => {
    const { name, value } = e.target;
    setPaymentForm(prev => ({ ...prev, [name]: value }));
  };

  const handleAddPaymentMethod = () => {
    const amount = parseFloat(paymentForm.amount);

    if (!amount || amount <= 0) {
      ToastService.error('Please enter a valid amount.', 'error', 3000);
      return;
    }

    if (!selectedCollection) {
      ToastService.error('Collection information is not available.', 'error', 3000);
      return;
    }

    // const collectionAmount = selectedCollection.amount || 0;
    // const totalCollected = paymentMethods.reduce((sum, p) => sum + p.amount, 0);
    // const remainingBalance = collectionAmount - totalCollected;
const collectionAmount = selectedCollection.credit?.remainingAmount || selectedCollection.amount || 0;
    const totalCollected = paymentMethods.reduce((sum, p) => sum + p.amount, 0);
    const remainingBalance = collectionAmount - totalCollected;

    if (amount > remainingBalance) {
      ToastService.error(`Amount exceeds remaining balance of ${formatCurrency(remainingBalance)}`, 'error', 3000);
      return;
    }

    // Validate payment method specific fields
    if (paymentForm.method === 'CHEQUE') {
      if (!paymentForm.chequeNumber || !paymentForm.bank || !paymentForm.chequeDate) {
        ToastService.error('Cheque number, bank, and cheque date are required for cheque payments.', 'error', 3000);
        return;
      }
    }

    if (paymentForm.method === 'BANK_TRANSFER' || paymentForm.method === 'CARD') {
      if (!paymentForm.reference) {
        ToastService.error('Reference number is required for bank transfers and card payments.', 'error', 3000);
        return;
      }
    }

    const newPaymentMethod = {
      method: paymentForm.method,
      amount: amount,
      notes: paymentForm.notes || '',
      chequeNumber: paymentForm.chequeNumber || '',
      bank: paymentForm.bank || '',
      chequeDate: paymentForm.chequeDate || '',
      reference: paymentForm.reference || '',
      collectionId: selectedCollection.id
    };

    setPaymentMethods(prev => [...prev, newPaymentMethod]);
    resetPaymentForm();
  };

  const handleRemovePaymentMethod = (index) => {
    setPaymentMethods(prev => prev.filter((_, i) => i !== index));
  };

  const handleResetPaymentMethods = () => {
    setPaymentMethods([]);
    resetPaymentForm();
  };

  const getTotalCollected = () => {
    return paymentMethods.reduce((sum, payment) => sum + payment.amount, 0);
  };

  const getRemainingBalance = () => {
    // if (!selectedCollection) return 0;
    // const collectionAmount = selectedCollection.credit?.remainingAmount || 0;
    // return collectionAmount - getTotalCollected();
      if (!selectedCollection) return 0;
    const collectionAmount = selectedCollection.credit?.remainingAmount || selectedCollection.amount || 0;
    return collectionAmount - getTotalCollected();
  };

  const handleSubmitPayment = async () => {
    const totalCollected = getTotalCollected();

    if (totalCollected <= 0) {
      ToastService.error('Please add at least one payment method.', 'error', 3000);
      return;
    }

    if (!selectedCollection) {
      ToastService.error('No collection selected.', 'error', 3000);
      return;
    }

    const invId = await ShiftService.getActiveInventoryId();

    // Prepare payment data
    const paymentData = {
      collectionId: selectedCollection.id,
      creditId: selectedCollection.credit?.id,
      inventoryId: invId,
      totalAmount: totalCollected,
      notes: paymentMethods.map(p => p.notes).filter(n => n).join(', ') || 'Credit payment',
      paymentMethods: paymentMethods.map(payment => ({
        method: payment.method,
        amount: payment.amount,
        notes: payment.notes || '',
        ...(payment.method === 'CHEQUE' && {
          chequeNumber: payment.chequeNumber,
          bank: payment.bank,
          chequeDate: payment.chequeDate
        }),
        ...((payment.method === 'BANK_TRANSFER' || payment.method === 'CARD') && {
          reference: payment.reference
        })
      }))
    };

    try {
      setLoading(prev => ({ ...prev, submitting: true }));

      const response = await CreditService.processCreditPayment(paymentData);

      if (response.success) {
        ToastService.success(`Payment of ${formatCurrency(totalCollected)} recorded successfully!`, 'success', 3000);
        try {
          await printCollectionReceipt();
        } catch (printError) {
          console.error('Receipt printing failed:', printError);
          ToastService.warning('Payment recorded but receipt printing failed', 'warning', 2000);
        }
        setShowPaymentModal(false);
        setSelectedCollection(null);
        setPaymentMethods([]);
        fetchCollections();
      } else {
        ToastService.error(response.message || 'Failed to record payment.', 'error', 3000);
      }
    } catch (error) {
      ToastService.error(error.message || 'Failed to record payment.', 'error', 3000);
    } finally {
      setLoading(prev => ({ ...prev, submitting: false }));
    }
  };

  const handleStartShift = () => {
    navigate('/dashboard');
    ToastService.info('Please start a shift first to manage credit payments.', 'info', 3000);
  };

  // Helper to show/hide payment method specific fields
  const showChequeFields = paymentForm.method === 'CHEQUE';
  const showReferenceField = paymentForm.method === 'BANK_TRANSFER' || paymentForm.method === 'CARD';

  return (
      <div className="min-h-screen bg-gray-50 overflow-y-auto">
        <Sidebar isOpen={showSidebar} onClose={() => setShowSidebar(false)} />

        {showSidebar && (
            <div
                className="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity"
                onClick={() => setShowSidebar(false)}
            />
        )}

        {/* Header */}
        <header className="sticky top-0 z-30 bg-gradient-to-r from-[#0613cc] to-[#0613cc] shadow-lg">
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <div className="flex items-center gap-3 sm:gap-4">
                <button
                    className="p-2 -ml-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors lg:hidden"
                    onClick={() => setShowSidebar(true)}
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                </button>
                <h1 className="text-lg sm:text-xl font-semibold text-white">Credit Collections</h1>
              </div>

              {routeInfo && (
                  <span className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium bg-white/20 text-white">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                </svg>
                    {routeInfo.name}
              </span>
              )}
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8 max-w-7xl mx-auto">
          {!shiftActive ? (
              <div className="rounded-2xl shadow-lg p-8 sm:p-12 text-center bg-white">
                <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center">
                  <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Shift Not Started</h3>
                <p className="text-gray-600 mb-6 max-w-md mx-auto">
                  You need to start a shift first to manage credit collections.
                </p>
                <button
                    className="px-6 py-3 rounded-lg font-semibold text-white transition-all transform hover:scale-105 active:scale-95 shadow-lg"
                    style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
                    onClick={handleStartShift}
                >
              <span className="flex items-center gap-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Go to Dashboard to Start Shift
              </span>
                </button>
              </div>
          ) : (
              <>
                {/* Filters Section */}
                <div className="mb-6 space-y-4">
                  {/* Route Info Badge (Mobile) */}
                  {routeInfo && (
                      <div className="sm:hidden flex items-center gap-2 px-3 py-2 rounded-lg bg-blue-50 border border-blue-200">
                        <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                        </svg>
                        <span className="text-sm font-medium text-blue-900">{routeInfo.name}</span>
                      </div>
                  )}

                  {/* Search Bar */}
                  <div className="relative">
                    <input
                        type="text"
                        placeholder="Search by code, customer name, or ID..."
                        value={searchTerm}
                        onChange={handleSearch}
                        disabled={loading.collections}
                        className="w-full pl-10 pr-4 py-2.5 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
                    />
                    <svg
                        className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>

                  {/* Date Filters */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                      <label htmlFor="startDate" className="block text-xs font-medium text-gray-700 mb-1">Start Date</label>
                      <input
                          type="date"
                          id="startDate"
                          name="startDate"
                          value={dateRange.startDate}
                          onChange={handleDateChange}
                          disabled={loading.collections}
                          className="w-full px-3 py-2 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
                      />
                    </div>
                    <div>
                      <label htmlFor="endDate" className="block text-xs font-medium text-gray-700 mb-1">End Date</label>
                      <input
                          type="date"
                          id="endDate"
                          name="endDate"
                          value={dateRange.endDate}
                          onChange={handleDateChange}
                          disabled={loading.collections}
                          className="w-full px-3 py-2 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
                      />
                    </div>
                  </div>

                  {/* Clear Filters Button */}
                  <button
                      onClick={handleClearFilters}
                      disabled={loading.collections}
                      className="w-full sm:w-auto px-4 py-2.5 rounded-lg bg-white border-2 border-gray-200 text-gray-700 font-medium hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    Clear Filters
                  </button>
                </div>

                {/* Collections List */}
                {loading.collections ? (
                    <div className="flex flex-col items-center justify-center py-20">
                      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
                      <p className="text-gray-600">Loading credit collections...</p>
                    </div>
                ) : collections.length > 0 ? (
                    <>
                      <div className="grid grid-cols-1 gap-4 sm:gap-6">
                        {collections.map((collection) => {
                          const status = getPaymentStatus(collection);
                          const collectionAmount = collection.amount || 0;
                          const creditAmount = collection.credit?.amount || 0;
                          const remainingAmount = collection.credit?.remainingAmount || 0;
                          const code = collection.code || `COL-${String(collection.id).padStart(6, '0')}`;
                          const customerName = collection.credit?.customer?.name || 'N/A';
                          const customerId = collection.credit?.customer?.id || 'N/A';
                          const creditStatus = collection.credit?.status || 'N/A';

                          return (
                              <div
                                  key={collection.id}
                                  className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow overflow-hidden border border-gray-100"
                              >
                                {/* Card Header */}
                                <div className="bg-gradient-to-r from-[#0613cc] to-[#0613cc] px-4 py-3 flex items-center justify-between">
                                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
                                    <span className="text-xs font-medium text-white/80">ID: {collection.id}</span>
                                    <span className="text-sm font-semibold text-white">{code}</span>
                                  </div>
                                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusBadge(status)}`}>
                            {status}
                          </span>
                                </div>

                                {/* Card Body */}
                                <div className="p-4 space-y-4">
                                  {/* Customer Info */}
                                  <div>
                                    <div className="flex items-center gap-2 mb-2">
                                      <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                      </svg>
                                      <span className="text-xs text-gray-500 font-medium">Customer</span>
                                    </div>
                                    <p className="text-sm font-semibold text-gray-900">{customerName}</p>
                                    {customerId && customerId !== 'N/A' && (
                                        <p className="text-xs text-gray-500 mt-1">ID: {customerId}</p>
                                    )}
                                  </div>

                                  {/* Amount Details */}
                                  <div className="grid grid-cols-2 gap-4 pt-3 border-t border-gray-100">
                                    <div>
                                      <div className="flex items-center gap-2 mb-2">
                                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        <span className="text-xs text-gray-500 font-medium">Credit Amount</span>
                                      </div>
                                      <p className="text-sm font-bold text-gray-900">{formatCurrency(creditAmount)}</p>
                                    </div>

                                    <div>
                                      <div className="flex items-center gap-2 mb-2">
                                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg>
                                        <span className="text-xs text-gray-500 font-medium">Collection</span>
                                      </div>
                                      <p className="text-sm font-bold text-blue-600">{formatCurrency(collectionAmount)}</p>
                                    </div>
                                  </div>

                                  {/* Remaining Amount */}
                                  <div className="pt-3 border-t border-gray-100">
                                    <div className="flex items-center gap-2 mb-2">
                                      <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                                      </svg>
                                      <span className="text-xs text-gray-500 font-medium">Remaining Amount</span>
                                    </div>
                                    <p className={`text-lg font-bold ${remainingAmount > 0 ? 'text-red-600' : 'text-green-600'}`}>
                                      {formatCurrency(remainingAmount)}
                                    </p>
                                  </div>

                                  {/* Credit Status */}
                                  {creditStatus && creditStatus !== 'N/A' && creditStatus !== status && (
                                      <div className="pt-3 border-t border-gray-100">
                                        <div className="flex items-center gap-2 mb-2">
                                          <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                          </svg>
                                          <span className="text-xs text-gray-500 font-medium">Credit Status</span>
                                        </div>
                                        <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${getStatusBadge(creditStatus)}`}>
                                {creditStatus}
                              </span>
                                      </div>
                                  )}

                                  {/* Date */}
                                  <div className="pt-3 border-t border-gray-100">
                                    <div className="flex items-center gap-2 mb-2">
                                      <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                      </svg>
                                      <span className="text-xs text-gray-500 font-medium">Created Date</span>
                                    </div>
                                    <p className="text-sm font-semibold text-gray-900">{formatDate(collection.createdAt)}</p>
                                  </div>

                                  {/* Action Button */}
                                  <div className="pt-3">
                                    <button
                                        onClick={() => handleOpenPaymentModal(collection)}
                                        disabled={loading.submitting || collection.status === 'PAID'}
                                        className={`w-full px-4 py-2.5 rounded-lg font-medium transition-all flex items-center justify-center gap-2 ${
                                            collection.status === 'PAID'
                                                ? 'bg-green-100 text-green-700 cursor-not-allowed'
                                                : 'bg-gradient-to-r from-[#0613cc] to-[#0613cc] text-white hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed'
                                        }`}
                                    >
                                      {collection.status === 'PAID' ? (
                                          <>
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                            Paid
                                          </>
                                      ) : (
                                          <>
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                                            </svg>
                                            Collect Payment
                                          </>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                          );
                        })}
                      </div>

                      {/* Pagination */}
                      {pagination.totalPages > 1 && (
                          <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 bg-white rounded-xl shadow-md p-4">
                            <button
                                onClick={() => handlePageChange(pagination.currentPage - 1)}
                                disabled={pagination.currentPage === 1 || loading.collections}
                                className="w-full sm:w-auto px-4 py-2.5 rounded-lg bg-gradient-to-r from-[#0f6652] to-[#0f6652] text-white font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
                            >
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                              </svg>
                              Previous
                            </button>

                            <div className="text-center">
                              <p className="text-sm font-semibold text-gray-900">
                                Page {pagination.currentPage} of {pagination.totalPages}
                              </p>
                              {pagination.total > 0 && (
                                  <p className="text-xs text-gray-500 mt-1">
                                    {pagination.total} total collections
                                  </p>
                              )}
                            </div>

                            <button
                                onClick={() => handlePageChange(pagination.currentPage + 1)}
                                disabled={pagination.currentPage === pagination.totalPages || loading.collections}
                                className="w-full sm:w-auto px-4 py-2.5 rounded-lg bg-gradient-to-r from-[#0f6652] to-[#0f6652] text-white font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
                            >
                              Next
                              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                              </svg>
                            </button>
                          </div>
                      )}
                    </>
                ) : (
                    <div className="rounded-2xl shadow-lg p-12 text-center bg-white">
                      <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
                        {searchTerm || dateRange.startDate || dateRange.endDate ? (
                            <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        ) : (
                            <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                        )}
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        {searchTerm || dateRange.startDate || dateRange.endDate ? 'No collections found' : 'No credit collections'}
                      </h3>
                      <p className="text-gray-600">
                        {searchTerm || dateRange.startDate || dateRange.endDate
                            ? 'No collections matching your filters'
                            : 'No credit collections found for this route'}
                      </p>
                    </div>
                )}
              </>
          )}
        </main>

        {/* Payment Recording Modal */}
        {showPaymentModal && selectedCollection && (
            <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 overflow-y-auto">
              <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                {/* Modal Header */}
                <div className="sticky top-0 bg-gradient-to-r from-[#0613cc] to-[#0613cc] px-6 py-4 flex items-center justify-between rounded-t-2xl z-10">
                  <div>
                    <h2 className="text-lg font-semibold text-white">Credit Collection Payment</h2>
                    <p className="text-sm text-white/80 mt-1">{selectedCollection.code || `Collection ${selectedCollection.id}`}</p>
                  </div>
                  <button
                      onClick={() => {
                        setShowPaymentModal(false);
                        setSelectedCollection(null);
                        setPaymentMethods([]);
                      }}
                      disabled={loading.submitting}
                      className="p-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors disabled:opacity-50"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                {/* Modal Body */}
                <div className="p-6 space-y-6">
                  {/* Collection Info Section */}
                  <div className="bg-gray-50 rounded-xl p-4 space-y-3">
                    <h3 className="text-sm font-semibold text-gray-900 mb-3">Collection Details</h3>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
                      <div>
                        <span className="text-gray-500">Collection Code:</span>
                        <p className="font-semibold text-gray-900">{selectedCollection.code || `COL-${String(selectedCollection.id).padStart(6, '0')}`}</p>
                      </div>
                      <div>
                        <span className="text-gray-500">Customer:</span>
                        <p className="font-semibold text-gray-900">
                          {selectedCollection.credit?.customer?.name || 'N/A'}
                          {selectedCollection.credit?.customer?.id && ` (ID: ${selectedCollection.credit.customer.id})`}
                        </p>
                      </div>
                      <div>
                        <span className="text-gray-500">Original Credit Amount:</span>
                        <p className="font-semibold text-gray-900">{formatCurrency(selectedCollection.credit?.amount || 0)}</p>
                      </div>
                      <div>
                        <span className="text-gray-500">Remaining Credit Balance:</span>
                        <p className="font-semibold text-gray-900">{formatCurrency(selectedCollection.credit?.remainingAmount || 0)}</p>
                      </div>
                      {/*<div>*/}
                      {/*  <span className="text-gray-500">Collection Amount:</span>*/}
                      {/*  <p className="font-semibold text-blue-600">{formatCurrency(selectedCollection.amount || 0)}</p>*/}
                      {/*</div>*/}
                      <div>
                        <span className="text-gray-500">Collection Status:</span>
                        <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${getStatusBadge(getPaymentStatus(selectedCollection))}`}>
                      {getPaymentStatus(selectedCollection)}
                    </span>
                      </div>
                    </div>
                  </div>

                  {/* Payment Form Section */}
                  <div className="border border-gray-200 rounded-xl p-4">
                    <h3 className="text-sm font-semibold text-gray-900 mb-4">Add Payment Method</h3>

                    <div className="space-y-4">
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                          <label htmlFor="method" className="block text-xs font-medium text-gray-700 mb-1">Payment Method *</label>
                          <select
                              id="method"
                              name="method"
                              value={paymentForm.method}
                              onChange={handlePaymentFormChange}
                              disabled={loading.submitting}
                              className="w-full px-3 py-2 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed"
                          >
                            <option value="CASH">Cash</option>
                            <option value="CHEQUE">Cheque</option>
                            <option value="BANK_TRANSFER">Bank Transfer</option>
                            <option value="CARD">Card</option>
                          </select>
                        </div>

                        <div>
                          <label htmlFor="amount" className="block text-xs font-medium text-gray-700 mb-1">Amount *</label>
                          <input
                              type="number"
                              id="amount"
                              name="amount"
                              value={paymentForm.amount}
                              onChange={handlePaymentFormChange}
                              min="1"
                              max={getRemainingBalance()}
                              placeholder="Enter amount"
                              disabled={loading.submitting}
                              className="w-full px-3 py-2 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed"
                          />
                          <p className="text-xs text-gray-500 mt-1">Max: {formatCurrency(getRemainingBalance())}</p>
                        </div>
                      </div>

                      <div>
                        <label htmlFor="notes" className="block text-xs font-medium text-gray-700 mb-1">Notes</label>
                        <input
                            type="text"
                            id="notes"
                            name="notes"
                            value={paymentForm.notes}
                            onChange={handlePaymentFormChange}
                            placeholder="Optional notes"
                            disabled={loading.submitting}
                            className="w-full px-3 py-2 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed"
                        />
                      </div>

                      {/* Cheque specific fields */}
                      {showChequeFields && (
                          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                            <div>
                              <label htmlFor="chequeNumber" className="block text-xs font-medium text-gray-700 mb-1">Cheque Number *</label>
                              <input
                                  type="text"
                                  id="chequeNumber"
                                  name="chequeNumber"
                                  value={paymentForm.chequeNumber}
                                  onChange={handlePaymentFormChange}
                                  placeholder="Enter cheque number"
                                  disabled={loading.submitting}
                                  className="w-full px-3 py-2 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed"
                              />
                            </div>
                            <div>
                              <label htmlFor="bank" className="block text-xs font-medium text-gray-700 mb-1">Bank *</label>
                              <input
                                  type="text"
                                  id="bank"
                                  name="bank"
                                  value={paymentForm.bank}
                                  onChange={handlePaymentFormChange}
                                  placeholder="Bank name"
                                  disabled={loading.submitting}
                                  className="w-full px-3 py-2 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed"
                              />
                            </div>
                            <div>
                              <label htmlFor="chequeDate" className="block text-xs font-medium text-gray-700 mb-1">Cheque Date *</label>
                              <input
                                  type="date"
                                  id="chequeDate"
                                  name="chequeDate"
                                  value={paymentForm.chequeDate}
                                  onChange={handlePaymentFormChange}
                                  disabled={loading.submitting}
                                  className="w-full px-3 py-2 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed"
                              />
                            </div>
                          </div>
                      )}

                      {/* Reference field for Bank Transfer and Card */}
                      {showReferenceField && (
                          <div>
                            <label htmlFor="reference" className="block text-xs font-medium text-gray-700 mb-1">Reference Number *</label>
                            <input
                                type="text"
                                id="reference"
                                name="reference"
                                value={paymentForm.reference}
                                onChange={handlePaymentFormChange}
                                placeholder="Enter reference number"
                                disabled={loading.submitting}
                                className="w-full px-3 py-2 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed"
                            />
                          </div>
                      )}

                      <button
                          onClick={handleAddPaymentMethod}
                          disabled={loading.submitting || getRemainingBalance() <= 0}
                          className="w-full px-4 py-2.5 rounded-lg bg-blue-800 text-white font-medium hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
                      >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                        Add Payment Method
                      </button>
                    </div>
                  </div>

                  {/* Payment Methods Added */}
                  <div className="border border-gray-200 rounded-xl p-4">
                    <h3 className="text-sm font-semibold text-gray-900 mb-4">Payment Methods Added</h3>

                    {paymentMethods.length === 0 ? (
                        <div className="text-center py-8">
                          <svg className="w-12 h-12 mx-auto text-gray-300 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                          </svg>
                          <p className="text-gray-500 text-sm">No payment methods added yet</p>
                        </div>
                    ) : (
                        <div className="space-y-3">
                          {paymentMethods.map((payment, index) => (
                              <div key={index} className="bg-gray-50 rounded-lg p-3 flex items-start justify-between">
                                <div className="flex-1">
                                  <div className="flex items-center gap-2 mb-1">
                                    <span className="text-sm font-semibold text-gray-900">{payment.method}</span>
                                    <span className="text-sm font-bold text-blue-600">{formatCurrency(payment.amount)}</span>
                                  </div>
                                  {payment.method === 'CHEQUE' && (
                                      <p className="text-xs text-gray-600">
                                        Cheque: {payment.chequeNumber} - {payment.bank}
                                      </p>
                                  )}
                                  {(payment.method === 'BANK_TRANSFER' || payment.method === 'CARD') && (
                                      <p className="text-xs text-gray-600">Ref: {payment.reference}</p>
                                  )}
                                  {payment.notes && (
                                      <p className="text-xs text-gray-600">Note: {payment.notes}</p>
                                  )}
                                </div>
                                <button
                                    onClick={() => handleRemovePaymentMethod(index)}
                                    disabled={loading.submitting}
                                    className="p-1 text-red-600 hover:bg-red-50 rounded transition-colors disabled:opacity-50"
                                >
                                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                  </svg>
                                </button>
                              </div>
                          ))}
                        </div>
                    )}
                  </div>

                  {/* Summary */}
                  <div className="bg-blue-50 rounded-xl p-4 space-y-2">
                    <div className="flex justify-between items-center">
                      <span className="text-sm font-medium text-gray-700">Total Payment:</span>
                      <span className="text-lg font-bold text-blue-600">{formatCurrency(getTotalCollected())}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-sm font-medium text-gray-700">Remaining Balance:</span>
                      <span className={`text-lg font-bold ${getRemainingBalance() > 0 ? 'text-red-600' : 'text-green-600'}`}>
                    {formatCurrency(getRemainingBalance())}
                  </span>
                    </div>
                  </div>
                </div>

                {/* Modal Footer */}
                <div className="sticky bottom-0 bg-white border-t border-gray-200 px-6 py-4 flex flex-col sm:flex-row gap-3 rounded-b-2xl">
                  <button
                      onClick={handleResetPaymentMethods}
                      disabled={loading.submitting || paymentMethods.length === 0}
                      className="flex-1 px-4 py-2.5 rounded-lg bg-white border-2 border-gray-200 text-gray-700 font-medium hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                  >
                    Reset Payments
                  </button>
                  <button
                      onClick={handleSubmitPayment}
                      disabled={loading.submitting || getTotalCollected() <= 0}
                      className="flex-1 px-4 py-2.5 rounded-lg bg-gradient-to-r from-[#0613cc] to-[#0613cc] text-white font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
                  >
                    {loading.submitting ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                          Processing...
                        </>
                    ) : (
                        <>
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          Submit Payment
                        </>
                    )}
                  </button>
                </div>
              </div>
            </div>
        )}
      </div>
  );
};

export default Credit;